// extracted by mini-css-extract-plugin
export default {"download":"RrHndXrcUVClCL8GaBAB","popper":"r5hHif2EJNn4EOUwQ36t"};